import {
  DEPARTMENTS_CLEAR_ERROR,
  DEPARTMENTS_FETCH_FAIL,
  DEPARTMENTS_FETCH_REQUEST,
  DEPARTMENTS_FETCH_SUCCESS,
} from "../constants/DepartmentConstants";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const DepartmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEPARTMENTS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DEPARTMENTS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload || [],
      };
    case DEPARTMENTS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DEPARTMENTS_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
